import React from 'react'

import mini_map from './../../../UI/icons/Map/mini-map.jpg'
import mini_map2 from './../../../UI/icons/Map/mini-map2.jpg'

import mobileAndTabletCheck from './../../../utils/mobileCheck'

import 'ol/ol.css'
import { Circle as circleStyle, Text, Fill, Icon, Style, Stroke } from "ol/style";
import { Feature, Map, Overlay, View } from "ol/index";
import { OSM, BingMaps, Vector as VectorSource } from "ol/source";
import { Point, Circle, MultiPoint, LineString, Polygon } from "ol/geom";
import {
  Tile as TileLayer,
  Vector as VectorLayer,
  Group as GroupLayer,
} from "ol/layer";
import { Control, FullScreen, defaults as defaultControls } from "ol/control";
import { fromLonLat, useGeographic } from "ol/proj";
import { getVectorContext } from "ol/render";

let imageSize = ["100vw", "100vh"];
let barOffset = 0;
if (mobileAndTabletCheck() && window.innerHeight > window.innerWidth) {
  barOffset = 5;
  imageSize = ["calc(84vh * 1.77778)", "84vh"];
}

interface MapComponent{
    view: any,
    vectorial: any,
    satellital: any,
    olmap: any,
    features: any,
    routeFeature: any,
    loteFeature: any,
    iconsLayer: any,
}

interface Props{
    showedMap: boolean,
    textures: any,
    proyecto: any,
    puntosInteres: any
    animate: boolean,
    changeAnimation: any,
    isVias: boolean,
    isBeneficios: boolean,
    childRef: any,
    notifyMapData: any,
}

interface State{
    vectorial: boolean,
    satellital: boolean,
    animated: boolean ,
    zoom: any,
    center: any
}

class MapComponent extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {
            vectorial: true,
            satellital: false,
            animated: false,
            zoom: 0,
            center: 0
        }

        this.view = new View({
            projection: "EPSG:4326",
            center: this.props.proyecto.Ubicacion[0].Center,
            zoom: this.props.proyecto.Ubicacion[0].Zoom,
            minZoom: this.props.proyecto.Ubicacion[0].MinZoom,
            maxZoom: this.props.proyecto.Ubicacion[0].MaxZoom
        })

        this.vectorial = new TileLayer({
            visible: this.state.vectorial,
            source: new OSM()
        });

        this.satellital = new TileLayer({
            visible: this.state.satellital,
            source: new BingMaps({
                key: "AvHvZsy-Fdm5hcTl-4QwbkSUQMIvcBd3XG33UU6G4TZCVB_oMSVuVZ0g-LPgzmP3",
                imagerySet: "AerialWithLabelsOnDemand",
            })
        })

        this.olmap = new Map({
            target: "",
            layers: [this.vectorial, this.satellital],
            view: this.view
        })
    }

 //------------------------------------------------------------------

  /** this function is temporary */
  hexToRGB = (hex, alpha) => {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    //if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    /*} else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
    }*/
  } 

  /** this function is temporary */
  mobileCheck = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };



  iconStyle = (icono, feature, resolution) => {
    return [
      new Style({
        image: new Icon({
          crossOrigin: "anonymous",
          scale: [0.009 / Math.pow(resolution, 1 / 3), 0.009 / Math.pow(resolution, 1 / 3)],
          src: this.props.textures[icono],
        }),
        text: new Text({
          text: feature.get('description'),
          offsetX: .75 / Math.pow(resolution, 1 / 3),
          scale: 0.035 / Math.pow(resolution, 1 / 3),
          fill: new Fill({
            color: "#fff"
          }),
          stroke: new Stroke({
            color: "#000",
            width: 2
          }),
          textAlign: 'left'
        })
      })
    ]
  }
  
  refreshPoints = () => {
    this.features = [];
    if (Object.keys(this.props.puntosInteres).length > 0) {
      this.props.puntosInteres.puntos.forEach((element) => {
        let PuntoInteres = new Feature({
          geometry: new Point([element.latitud, element.longitud]),
        });
        
        PuntoInteres.set('description', element.nombre);
        PuntoInteres.setStyle(this.iconStyle(this.props.puntosInteres.icono, PuntoInteres, this.olmap.get('view').get('resolution')));

        this.features.push(PuntoInteres);
      });

      if (!this.props.animate) {
        this.props.changeAnimation(true)
        if (typeof window.orientation !== 'undefined') {
          this.updateMap(this.props.puntosInteres.center, this.props.puntosInteres.zoom * .87);  
        } else {
          this.updateMap(this.props.puntosInteres.center, this.props.puntosInteres.zoom - (((100 - ((window.innerWidth * 100) / 1920 )) / 20) * 0.5));
        }
        
      }
    } else {
      if (!this.props.animate) {
        this.props.changeAnimation(true)
        if (typeof window.orientation !== 'undefined') {
          this.updateMap(this.props.proyecto.Ubicacion[0].Center, this.props.proyecto.Ubicacion[0].Zoom * .87);
        } else {
          this.updateMap(this.props.proyecto.Ubicacion[0].Center, this.props.proyecto.Ubicacion[0].Zoom - (((100 - ((window.innerWidth * 100) / 1920 )) / 20) * 0.5));
        }
        
      }
    }

     /** lote svg */
    /*let loteFeature = new Feature({
      // custom offsets
      geometry: new Point([this.props.proyecto.Ubicacion[0].Center[0] - 0.00182, this.props.proyecto.Ubicacion[0].Center[1] + 0.00048], 50),
    });

    let loteIconStyle = new Style({
      image: new Icon({
        crossOrigin: "anonymous",
        scale: [0, 0],
        src: this.props.textures['Images/PuntosDeInteres/lote-proyecto.svg'],
      }),
    });

    loteFeature.setStyle((feature, resolution) => {
      // custom scale
      loteIconStyle.getImage().setScale(this.olmap.getView().getResolutionForZoom(16.515) / resolution);
      return loteIconStyle;
    });

    this.features.push(loteFeature);*/


    /** logo escalable con lote*/
    /*let logoFeature = new Feature({
      // custom offsets
      geometry: new Point([this.props.proyecto.Ubicacion[0].Center[0] + 0.00015, this.props.proyecto.Ubicacion[0].Center[1] + 0.00015] , 50),
    });

    let iconStyle = new Style({
      image: new Icon({
        crossOrigin: "anonymous",
        scale: [0, 0],
        src: this.props.textures['Images/PuntosDeInteres/logo-proyecto.svg'],
      }),
    });

    logoFeature.setStyle((feature, resolution) => {
      //iconStyle.getImage().setScale(0.009 / Math.pow(resolution, 1 / 3));
      iconStyle.getImage().setScale(this.olmap.getView().getResolutionForZoom(18.2) / resolution);
      return iconStyle;
    });

    this.features.push(logoFeature);*/

    /*logo*/

    let logoFeature = new Feature({
    geometry: new Point(this.props.proyecto.Ubicacion[0].Center, 50),
    });

    let iconStyle = new Style({
    image: new Icon({
        crossOrigin: "anonymous",
        scale: [0, 0],
        src: this.props.textures['Images/PuntosDeInteres/logo-proyecto.svg'],
    }),
    });

    logoFeature.setStyle(function (feature, resolution) {
    iconStyle.getImage().setScale(0.009 / Math.pow(resolution, 1 / 3));
    return iconStyle;
    });

    this.features.push(logoFeature);

    if (this.props.proyecto.Ubicacion[0].Vias !== undefined && this.props.isVias) {
        this.props.proyecto.Ubicacion[0].Vias.forEach(element => {
        var route = new LineString(element.via);

        this.routeFeature = new Feature({
        geometry: route,
        });

        this.routeFeature.setStyle(
        new Style({
            stroke: new Stroke({
                width: 10,
                color: this.hexToRGB(element.color, 0.85)
            }),
            })
        )

        this.features.push(this.routeFeature);
        });
    }

    if (this.props.proyecto.Ubicacion[0].Lote !== undefined) {
        this.loteFeature = new Feature({
        geometry: new Polygon(this.props.proyecto.Ubicacion[0].Lote),
        });

        this.loteFeature.setStyle(
        new Style({
            stroke: new Stroke({
                width: 6,
                color: 'rgba(24, 77, 71, .8)',
            }),
            fill: new Fill({
                color: 'rgba(24, 77, 71, 0.15)',
            })
            })
        )

    this.features.push(this.loteFeature);
    }

    this.olmap.removeLayer(this.iconsLayer);

    this.iconsLayer = new VectorLayer({
        source: new VectorSource({
        features: this.features,
        }),
    });

    this.olmap.addLayer(this.iconsLayer);
    };

    updateMap = (center, zoom) => {
        this.view.animate({ zoom: zoom  , center: center });
    };

    componentDidMount() {

      if(window.innerHeight < window.innerWidth){
        console.log("rotation")
      }

      const { childRef } = this.props;
      childRef(this);

      this.olmap.setTarget("map");

      // Listen to map changes
      this.olmap.on("moveend", () => {
          let center = this.olmap.getView().getCenter();
          let zoom = this.olmap.getView().getZoom();
          this.setState({ center, zoom });

          this.props.notifyMapData({ 
          mapCenter: center,
          mapZoom: zoom
          })
      });
    }

  componentWillUnmount(){
    const { childRef } = this.props;
    childRef(undefined);
  }

  componentDidUpdate(prevProps, prevState) {
    if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
      barOffset = 5;
      imageSize = ['calc(84% * 1.77778)', '84%'];
    }
    else {
      imageSize = ['100%', '100%'];
      barOffset = 0;
    }

    if(window.innerHeight < window.innerWidth){
      this.refreshPoints();
      this.olmap.render();
    }

    this.refreshPoints();
    this.olmap.render();
  }

  handleChangeMapa() {
    let arreglo = this.olmap.getLayers();
    arreglo.getArray()[0].setVisible(!this.state.vectorial);
    arreglo.getArray()[1].setVisible(!this.state.satellital);
    this.setState({
      vectorial: !this.state.vectorial,
      satellital: !this.state.satellital,
    });
    this.updateMap(this.props.puntosInteres.center, this.props.puntosInteres.zoom - (((100 - ((window.innerWidth * 100) / 1920 )) / 20) * 0.5));
  }

    render() {
        return (
            <div
                id="map"
                style={{
                backgroundColor: "black",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                }}
                className={this.props.isVias || this.props.isBeneficios ? "mapa fade-in":"mapa fade-out"}
            >
                <div
                className="minimap-button"
                onClick={() => this.handleChangeMapa()}
                >
                  <img height='100%' src={!this.state.vectorial ? mini_map2 : mini_map}/>
                </div>
            </div>
            );
        }
}

export default MapComponent